<template>
  <div class="slcb-home__hero-wrap">
    <div class="slcb-home__hero-container">
      <div class="slcb-home__hero-start-wrapper">
        <div class="slcb-home__hero-start-title-container">
          <h1 class="slcb-home__hero-title">Seja bem-vindo(a)!</h1>
          <h2 class="slcb-home__hero-title--sub">Sou o <span>Toddy</span> e vou ajudar a calcular o score jurídico da sua startup!</h2>
        </div>
        <div class="slcb-home__hero-start-toddy-container">
          <img src="../assets/img/android.svg" alt="Ilustração de um android">
          <b-link href="/toddy" class="btn slcb-home__hero-start-toddy">Iniciar conversa</b-link>
        </div>
      </div>
      <div class="slcb-home__powered-by">
        <ul>
          <li><img src="../assets/img/logos.svg" alt="Silva Lopes Advogados"></li>
          <li><img src="../assets/img/catarina.svg" alt="Logo Catarina"></li>
          <li><img src="../assets/img/darwin.svg" alt="Logo Darwin"></li>
          <li><img src="../assets/img/ace.svg" alt="Logo Ace Ventures"></li>
          <li><img src="../assets/img/invisto.svg" alt="Logo Invisto"></li>
        </ul>
        Powered by <a target="_blank" href="http://mocka.site" class="slcb-home__link slcb-home__link--doted">Mocka</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Home.vue